(function(){
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function fmt(c){ return (c/100).toLocaleString('de-DE',{style:'currency',currency:CUR}); }
  var COLOR = /farbe|color|colour/i, SIZE = /gr(ö|oe)(ß|ss)e|size/i;

  async function kfAdd(items){
    var cd = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cd) { body.sections = ['cart-drawer','cart-icon-bubble']; body.sections_url = location.pathname; }
    var r = await fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) });
    var data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || 'Fehler beim Hinzufügen');
    if (cd && data.sections && typeof cd.renderContents === 'function') { cd.renderContents(data); }
    else { location.href = (window.routes && routes.cart_url) || '/cart'; }
  }
  window.kfAdd = kfAdd;

  function initMenu(){
    var tpl = document.getElementById('kf-vm-tpl');
    var cont = document.querySelector('#menu-drawer .menu-drawer__navigation-container');
    if (tpl && cont && !cont.querySelector('.kf-vm')) cont.prepend(tpl.content.cloneNode(true));
    var dataEl = document.getElementById('kf-vm-data');
    if (!dataEl) return;
    var data = []; try { data = JSON.parse(dataEl.textContent); } catch(e) {}
    document.querySelectorAll('.mega-menu__list a').forEach(function(a){
      var path = a.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i,'');
      var hit = data.find(function(d){ return d.url === path; });
      if (hit && hit.img && !a.querySelector('img')) {
        var img = new Image(); img.src = hit.img; img.alt = ''; img.loading = 'lazy';
        a.classList.add('kf-mm'); a.prepend(img);
        var ul = a.closest('.mega-menu__list'); if (ul) ul.classList.add('kf-mm-grid');
      }
    });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('.kf-vm__tab'); if (!t) return;
    var vm = t.closest('.kf-vm');
    vm.querySelectorAll('.kf-vm__tab').forEach(function(b){ b.setAttribute('aria-selected', String(b === t)); });
    vm.querySelectorAll('.kf-vm__panel').forEach(function(p){ p.hidden = p.dataset.group !== t.dataset.group; });
  });

  function initEta(){
    document.querySelectorAll('[data-kf-eta]').forEach(function(el){
      var min = +el.dataset.min || 7, max = +el.dataset.max || 14, cut = +el.dataset.cutoff || 18;
      var d = new Date(); if (d.getHours() >= cut) d.setDate(d.getDate()+1);
      function add(n){ var x = new Date(d); var c = 0; while (c < n) { x.setDate(x.getDate()+1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; } return x; }
      var o = { weekday:'short', day:'2-digit', month:'2-digit' };
      el.innerHTML = 'Lieferung voraussichtlich <strong>' + add(min).toLocaleDateString('de-DE', o) + ' – ' + add(max).toLocaleDateString('de-DE', o) + '</strong>';
    });
  }

  function Bundle(root){
    this.root = root;
    this.p = JSON.parse(root.querySelector('[data-kf-product]').textContent);
    this.names = JSON.parse(root.dataset.options || '[]');
    this.variants = this.p.variants || [];
    this.values = this.names.map(function(n, i){ var s = []; this.variants.forEach(function(v){ if (s.indexOf(v.options[i]) < 0) s.push(v.options[i]); }); return s; }, this);
    var first = this.variants.find(function(v){ return v.available; }) || this.variants[0];
    this.base = this.names.map(function(n, i){ if (this.values[i].length === 1) return this.values[i][0]; if (SIZE.test(n)) return ''; return first.options[i]; }, this);
    this.items = [this.base.slice()];
    this.qty = 1;
    this.tiers = Array.prototype.slice.call(root.querySelectorAll('.kf-tier'));
    this.cta = root.querySelector('[data-kf-add]');
    this.err = root.querySelector('[data-err]');
    var self = this;
    this.tiers.forEach(function(t){ t.querySelector('.kf-tier__btn').addEventListener('click', function(){ self.setQty(+t.dataset.qty); }); });
    this.cta.addEventListener('click', function(){ self.add(); });
    this.sticky = root.querySelector('[data-kf-sticky]');
    if (this.sticky) { document.body.appendChild(this.sticky); this.sticky.querySelector('[data-st-btn]').addEventListener('click', function(){ self.isValid() ? self.add() : self.root.scrollIntoView({behavior:'smooth', block:'center'}); }); this.watch(); }
    var def = +(root.dataset.default || 2);
    this.setQty(this.tiers.some(function(t){ return +t.dataset.qty === def; }) ? def : 1);
  }
  Bundle.prototype.variantFor = function(vals){ return this.variants.find(function(v){ return v.options.every(function(o, i){ return o === vals[i]; }); }); };
  Bundle.prototype.priceFor = function(vals){
    var v = this.variantFor(vals);
    if (!v) v = this.variants.find(function(x){ return x.options.every(function(o, i){ return !vals[i] || o === vals[i]; }); }) || this.variants[0];
    return v;
  };
  Bundle.prototype.imgFor = function(i, val){
    var v = this.variants.find(function(x){ return x.options[i] === val && x.featured_image; });
    if (!v) return null; var s = v.featured_image.src; return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  };
  Bundle.prototype.setQty = function(q){
    var cur = this.items;
    this.items = []; for (var i = 0; i < q; i++) this.items.push((cur[i] || cur[0] || this.base).slice());
    this.qty = q; this.err.textContent = '';
    this.render();
  };
  Bundle.prototype.isValid = function(){ return this.items.every(function(it){ return it.every(function(x){ return x !== ''; }); }) && this.items.every(function(it){ var v = this.variantFor(it); return v && v.available; }, this); };
  Bundle.prototype.totals = function(q, off, useItems){
    var sum = 0, cmp = 0, self = this;
    for (var i = 0; i < q; i++) { var vals = useItems ? self.items[i] : self.items[0]; var v = self.priceFor(vals); sum += v.price; cmp += Math.max(v.compare_at_price || 0, v.price); }
    var total = Math.round(sum * (1 - off / 100));
    var was = off ? sum : (cmp > sum ? cmp : 0);
    return { total: total, was: was, per: Math.round(total / q) };
  };
  Bundle.prototype.render = function(){
    var self = this;
    this.tiers.forEach(function(t){
      var q = +t.dataset.qty, off = +t.dataset.off, on = q === self.qty;
      var tt = self.totals(q, off, on);
      t.classList.toggle('is-active', on);
      t.querySelector('.kf-tier__btn').setAttribute('aria-expanded', String(on));
      t.querySelector('[data-total]').textContent = fmt(tt.total);
      t.querySelector('[data-was]').textContent = tt.was ? fmt(tt.was) : '';
      t.querySelector('[data-per]').textContent = q === 1 ? 'Einzelpreis' : fmt(tt.per) + ' pro Stück · Farben & Größen frei wählbar';
      var box = t.querySelector('[data-items]');
      box.hidden = !on; box.innerHTML = '';
      if (on && self.names.length && !(self.names.length === 1 && self.values[0].length === 1)) box.appendChild(self.buildItems());
    });
    this.updateCta();
  };
  Bundle.prototype.buildItems = function(){
    var self = this, frag = document.createDocumentFragment();
    this.items.forEach(function(vals, idx){
      var row = document.createElement('div'); row.className = 'kf-item';
      var head = document.createElement('div'); head.className = 'kf-item__head';
      var b = document.createElement('b'); b.textContent = self.qty > 1 ? 'Stück ' + (idx + 1) : 'Deine Auswahl';
      var sm = document.createElement('span'); sm.textContent = vals.map(function(v, i){ return v || self.names[i] + ' wählen'; }).join(' · ');
      head.appendChild(b); head.appendChild(sm); row.appendChild(head);
      var opts = document.createElement('div'); opts.className = 'kf-item__opts';
      self.names.forEach(function(name, i){
        if (self.values[i].length === 1) return;
        if (COLOR.test(name)) {
          var wrap = document.createElement('div'); wrap.className = 'kf-sws'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', name);
          self.values[i].forEach(function(val){
            var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'kf-sw';
            btn.setAttribute('aria-pressed', String(vals[i] === val)); btn.setAttribute('aria-label', name + ': ' + val); btn.title = val;
            var src = self.imgFor(i, val);
            if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; btn.appendChild(im); }
            else { btn.classList.add('kf-sw--text'); btn.textContent = val; }
            btn.addEventListener('click', function(){ vals[i] = val; if (idx === 0) self.syncMedia(vals); self.render(); });
            wrap.appendChild(btn);
          });
          opts.appendChild(wrap);
        } else {
          var sel = document.createElement('select'); sel.className = 'kf-sel' + (vals[i] === '' ? ' is-missing' : ''); sel.setAttribute('aria-label', name + ' Stück ' + (idx + 1));
          var ph = document.createElement('option'); ph.value = ''; ph.textContent = name + ' wählen'; sel.appendChild(ph);
          self.values[i].forEach(function(val){
            var o = document.createElement('option'); o.value = val;
            var test = vals.slice(); test[i] = val; var v = self.variantFor(test);
            o.textContent = val + (v && !v.available ? ' (ausverkauft)' : ''); if (v && !v.available) o.disabled = true;
            if (vals[i] === val) o.selected = true; sel.appendChild(o);
          });
          sel.addEventListener('change', function(){ vals[i] = sel.value; self.err.textContent = ''; self.render(); });
          opts.appendChild(sel);
        }
      });
      row.appendChild(opts); frag.appendChild(row);
    });
    return frag;
  };
  Bundle.prototype.syncMedia = function(vals){
    var v = this.priceFor(vals); if (!v || !v.featured_media) return;
    var li = document.querySelector('[data-media-id$="-' + v.featured_media.id + '"]');
    var g = document.querySelector('media-gallery');
    if (li && g && typeof g.setActiveMedia === 'function') g.setActiveMedia(li.dataset.mediaId, false);
    if (this.sticky && v.featured_image) { this.sticky.querySelector('[data-st-img]').src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
  };
  Bundle.prototype.updateCta = function(){
    var t = this.tiers.find(function(x){ return +x.dataset.qty === this.qty; }, this);
    var tt = this.totals(this.qty, +t.dataset.off, true);
    var valid = this.isValid();
    var missing = null; var self = this;
    this.items.some(function(it){ var k = it.indexOf(''); if (k > -1) { missing = self.names[k]; return true; } return false; });
    this.cta.textContent = valid ? (this.qty > 1 ? this.qty + ' Stück hinzufügen · ' : 'In den Warenkorb · ') + fmt(tt.total) : (missing ? 'Bitte ' + missing + ' wählen' : 'Nicht verfügbar');
    this.cta.classList.toggle('is-wait', !valid);
    if (this.sticky) {
      this.sticky.querySelector('[data-st-total]').textContent = fmt(tt.total);
      this.sticky.querySelector('[data-st-was]').textContent = tt.was ? fmt(tt.was) : '';
      this.sticky.querySelector('[data-st-tag]').textContent = +t.dataset.off ? this.qty + ' Stück −' + t.dataset.off + ' %' : '';
      this.sticky.querySelector('[data-st-var]').textContent = this.items[0].filter(Boolean).join(' / ') || this.p.title;
      this.sticky.querySelector('[data-st-btn]').textContent = valid ? (this.qty > 1 ? this.qty + ' hinzufügen' : 'Hinzufügen') : 'Auswählen';
    }
  };
  Bundle.prototype.add = async function(){
    var self = this;
    if (!this.isValid()) {
      this.err.textContent = 'Bitte wähle für jedes Stück alle Optionen aus.';
      var m = this.root.querySelector('.kf-sel.is-missing'); if (m) { m.scrollIntoView({behavior:'smooth', block:'center'}); m.focus(); }
      return;
    }
    var map = {}; this.items.forEach(function(it){ var v = self.variantFor(it); map[v.id] = (map[v.id] || 0) + 1; });
    var items = Object.keys(map).map(function(id){ return { id: +id, quantity: map[id] }; });
    this.cta.disabled = true; var old = this.cta.textContent; this.cta.textContent = 'Wird hinzugefügt …';
    try { await kfAdd(items); this.err.textContent = ''; }
    catch (e) { this.err.textContent = e.message; }
    finally { this.cta.disabled = false; this.cta.textContent = old; this.updateCta(); }
  };
  Bundle.prototype.watch = function(){
    var st = this.sticky, cta = this.cta, self = this;
    var footer = document.querySelector('.footer, footer');
    var ctaOut = false, footIn = false;
    function upd(){ var show = ctaOut && !footIn; st.classList.toggle('is-visible', show); st.setAttribute('aria-hidden', String(!show)); st.querySelector('[data-st-btn]').tabIndex = show ? 0 : -1; }
    new IntersectionObserver(function(es){ es.forEach(function(e){ ctaOut = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }); }).observe(cta);
    if (footer) new IntersectionObserver(function(es){ es.forEach(function(e){ footIn = e.isIntersecting; upd(); }); }).observe(footer);
  };

  function init(){
    initMenu(); initEta();
    document.querySelectorAll('[data-kf-bundle]').forEach(function(el){ if (!el.kfInit) { el.kfInit = true; try { new Bundle(el); } catch(e) { console.error('KF bundle', e); } } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
